import { useTranslations } from 'next-intl';

/**
 * Hook to get translated category name from category ID
 * @param categoryId - The category ID (e.g., "music-dances", "personal-development")
 * @returns The translated category name or the original ID if no translation found
 */
export function useCategoryTranslation() {
  const t = useTranslations('Categories');

  return (categoryId: string | undefined): string => {
    if (!categoryId) {
      return '';
    }

    // Get the translation
    const translation = t(categoryId as any);

    // Check if the translation is just the key with namespace prefix (indicating missing translation)
    if (translation.startsWith('Categories.')) {
      // If translation key doesn't exist, return the original ID formatted nicely
      return categoryId
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
    }

    return translation;
  };
}
